let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jepjM")).then(() => parcelRequire('F35X1'));